<template>
  <div class="landing">
    <template>
      <div class="menu">
        <div class="container">
          <div class="container-fluid menu">
            <nav class="container navbar navbar-expand-lg">
              <router-link to="/">
                <img class="lazyload mt-5" width="40%" src="@/assets/img/logo-1.png" />
                <img class="lazyload mt-5" width="40%" src="@/assets/img/logo-2.png" />
              </router-link>
              <div class="navbar-collapse pull-right" id="navbarNavAltMarkup">
                <div class="navbar-nav ml-auto">
                  <router-link to="/clients" class="nav-item nav-link btn-signup">Clientes</router-link>
                  <span v-on:click="openModal" class="nav-item nav-link btn-login">Entrar</span>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </template>
    <router-view />
    <modal name="login" :adaptive="true" :minHeight="340" class="modalLogin">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('login')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <Login />
      <div class="text-center reset-pass" @click="$modal.hide('login')">
        <router-link to="/resetpassword">¿Olvidaste tu contraseña?</router-link>
      </div>
    </modal>
    <footer class="">
      <div class="container">
        <div class="row mb-2">
          <div class="col-sm-3 power-by">
            <!-- <div>
              <img class="lazyload" width="60%" src="@/assets/img/logo-1.png" />
            </div> -->
            <div>
              <img class="lazyload" width="80%" src="@/assets/img/logo-2.png" />
            </div>
            <Version />
          </div>
          <div class="col-sm-3 politic">
            <ul>
              <li>
                <!-- <router-link to="/legal/terms">Terminos y condiciones</router-link> -->
                Terminos y condiciones
              </li>
              <li>
                <!-- <router-link to="/legal/privacy">Aviso de privacidad</router-link> -->
                Aviso de privacidad
              </li>
              <li>Preguntas frecuentes</li>
            </ul>
          </div>
          <div class="col-sm-3 copy">
            <a href="" target="true" class="linke">
             <img class="lazyload" src="@/assets/img/facebook-icon.svg" />
            </a>
            <img class="lazyload linke" src="@/assets/img/linkedin-brands.svg" />
          </div>
          <div class="col-sm-3 copy">
            <b>© 2020 ISA´S derechos reservados.</b>
            <img class="lazyload linke" width="60%" src="@/assets/img/isass.png" />
          <br></div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
const Version = () => import('@/components/general/Version.vue')
const Login = () => import('@/views/Login.vue')

export default {
  components: {
    Version,
    Login
  },
  mounted () {
    console.log('La resolución de tu pantalla es: ' + screen.width + ' x ' + screen.height)
  },
  methods: {
    openModal () {
      this.$modal.show('login')
    }
  }
}
</script>

<style scoped lang="scss">
.modalLogin {
  z-index: 1000;
}
@media only screen and (max-width: 420px) {
  .landing {
    & .menu{
      width: 105%;
    }
    & footer {
      width: 106%;
    }
  }
}
@media only screen and (max-width:400px) {
  .footer {
    background-color: gray !important;
    .power-by {
      margin-top: 0px;
      & img {
        padding-bottom: 15px;
      }
    }
    & .politic {
      font-size: 17px;
      & a {
        color: #ffffff;
        text-decoration: none;
      }
      & ul li {
        padding-bottom: 15px;
        list-style-type: none;
        & img {
          padding-right: 20px;
          }
        }
      }
        & .copy {
            margin-top: 70px;
            font-size: 13px;
            vertical-align: middle;
        }
        & .linke {
            margin-left: 30px;
        }
    }
}

@media only screen and (max-width: 375px) {
  .landing {
    & .menu{
      width: 102%;
    }
    & footer {
      width: 102%;
    }
  }
}

@media only screen and (max-width: 360px) {
  .landing {
    color: #202020E6;
    & .menu{
      width: 106%;
    }
    & footer {
      width: 108%;
    }
  }
}

@media only screen and (max-width: 320px) {
  .landing {
    & .menu{
      width: 113%;
    }
    & footer {
      width: 122%;
    }
  }
}
</style>
